export default "__VITE_ASSET__BiEKy0pS__";